var _path, _g;
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContactRequest = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 168,
  height: 144,
  fill: "none",
  viewBox: "0 0 168 144",
  ...props,
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: 122,
    height: 126,
    x: 23,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M144.988 9.882H23.012v124.236h121.976z"
    }))
  }), _g || (_g = /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#777",
      d: "M58.126 100.63H54.98v20.591h3.146z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#777",
      d: "M68.987 123.282q-.056 0-.113-.006l-12.632-1.201a1.177 1.177 0 1 1 .224-2.344l12.633 1.201a1.176 1.176 0 0 1-.112 2.35"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#777",
      d: "M56.815 122.48c-.203 0-.408-.051-.596-.161l-6.417-3.753a1.176 1.176 0 0 1-.42-1.611 1.18 1.18 0 0 1 1.614-.42l6.417 3.753a1.176 1.176 0 0 1-.598 2.194z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#777",
      d: "M49.199 130.673a1.41 1.41 0 0 1-1.047-2.362l7.132-7.837a1.417 1.417 0 0 1 1.999-.095 1.41 1.41 0 0 1 .095 1.995l-7.131 7.837c-.28.307-.662.463-1.048.463zM47.773 52.503c-1.522-1.483-3.466-2.538-5.915-2.923-8.472-1.33-15.495 6.675-17.616 13.98-4.956 17.064 5.571 36.06 22.463 41.347 15.057 4.711 38.84-3.576 37.495-22.315-.208-2.887-1.237-5.79-3.34-7.848-1.83-1.791-4.311-2.808-6.831-3.29-6.459-1.235-13.793-.468-19.866 1.986-2.46.993-1.998-.257-1.853-2.537.087-1.38.395-2.8.371-4.182-.088-4.981-1.352-10.76-4.905-14.217z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#303030",
      d: "M112.71 134.118a7.87 7.87 0 0 1-7.087-4.435L87.893 93.09l-30.512-.649c-4.343-.092-7.789-3.681-7.697-8.015.093-4.334 3.686-7.775 8.033-7.68l35.33.75a7.86 7.86 0 0 1 6.913 4.43l19.827 40.924a7.84 7.84 0 0 1-3.658 10.483 7.85 7.85 0 0 1-3.419.785M118.738 42.35a2.144 2.144 0 0 0-2.146-2.142c-1.186 0-2.147.96-2.147 2.142v11.593c0 1.184.961 2.143 2.147 2.143s2.146-.96 2.146-2.142z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#303030",
      d: "m142.926 50.826-44.333-5.861c-1.135-.15-2.062-.93-2.062-1.733V16.746c0-.804.93-1.57 2.062-1.701l44.333-5.148c1.135-.132 2.062.687 2.062 1.819v37.325c0 1.132-.929 1.935-2.062 1.785"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00D639",
      d: "m140.817 48.15-40.704-5.132c-1.015-.128-1.845-.82-1.845-1.539V18.407c0-.72.83-1.399 1.845-1.511l40.704-4.507c1.015-.113 1.845.625 1.845 1.636v32.517c0 1.013-.83 1.736-1.845 1.608"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "m138.737 45.03-16.58-2.09c-.628-.08-1.142-.507-1.142-.952V32.69c0-.444.513-.866 1.142-.935l16.58-1.835c.628-.069 1.143.387 1.143 1.013v13.103c0 .627-.513 1.074-1.143.996z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00AF2D",
      d: "m111.239 41.445-5.455-.763c-.771-.108-1.401-.758-1.401-1.445V20.889c0-.675.618-1.325 1.374-1.446l5.482-.877c.771-.123 1.402.406 1.402 1.173v20.503c0 .77-.631 1.31-1.402 1.201z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00D639",
      d: "M103.51 34.524c-6.363 0-13.463-2.62-21.194-7.835a4.32 4.32 0 0 1-1.164-6.005 4.34 4.34 0 0 1 6.017-1.162c8.007 5.4 14.961 7.405 20.111 5.797 5.376-1.68 7.507-6.828 7.526-6.88a4.337 4.337 0 0 1 5.606-2.47 4.32 4.32 0 0 1 2.476 5.595c-.143.37-3.617 9.07-13.019 12.008q-3.043.95-6.361.95z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E84D4F",
      d: "m82.962 22.49.656-2.563a2.454 2.454 0 0 0-4.754-1.212l-.656 2.562a2.45 2.45 0 0 0 1.77 2.98 2.454 2.454 0 0 0 2.984-1.768"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#B26E3D",
      d: "m81.132 22.067-.8-2.521a2.455 2.455 0 0 0-3.08-1.595 2.45 2.45 0 0 0-1.598 3.074l.8 2.52a2.455 2.455 0 0 0 3.08 1.596 2.45 2.45 0 0 0 1.598-3.074"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#303030",
      d: "m124.182 74.204-33.154-6.871a1.336 1.336 0 0 1-.723-2.203l7.177-7.953a1.34 1.34 0 0 1 1.19-.427l30.479 4.493a1.337 1.337 0 0 1 1.033 1.856l-4.502 10.33a1.34 1.34 0 0 1-1.5.775M120.306 130.068l-11.439-4.031a1.24 1.24 0 0 0-1.579.754c-.228.643.11 1.349.755 1.576l11.438 4.031a1.235 1.235 0 1 0 .825-2.33M67.61 126.45l2.798-6.564a1.239 1.239 0 0 0-2.279-.967l-2.797 6.564a1.239 1.239 0 0 0 2.278.967"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "M57.06 52.678a4.42 4.42 0 0 1-4.393-3.942 4.417 4.417 0 0 1 3.916-4.862c3.314-.372 12.762-2.545 16.625-8.08 1.854-2.657 2.281-5.867 1.304-9.813a4.414 4.414 0 0 1 3.233-5.346 4.425 4.425 0 0 1 5.357 3.227c1.607 6.486.713 12.21-2.658 17.015-6.982 9.958-22.257 11.706-22.904 11.776a5 5 0 0 1-.48.025"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "M64.41 46.33c-3.21-2.705-6.03-2.14-6.443-2.209-3.195-.53-5.558 1.364-6.335 1.985-1.39 1.114-2.669 2.799-3.064 4.553-.446 1.983.19 4.246.356 6.244.217 2.613.515 5.224.772 7.834q.769 7.804 1.536 15.61c-.049-.393 4.988-1.843 5.472-2 .578-.186 2.014-.473 3.48-.765a5.3 5.3 0 0 0 4.228-4.606l2.597-23.39c-.08-.82-1.945-2.706-2.6-3.257z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#303030",
      d: "M74.412 127.593a7.86 7.86 0 0 1-5.613-2.349 7.84 7.84 0 0 1 .1-11.1l17.53-17.18-29.99-4.668c-4.293-.669-7.228-4.682-6.56-8.966.67-4.284 4.692-7.214 8.985-6.546l45.459 7.076a7.844 7.844 0 0 1 4.3 13.357l-28.7 28.129a7.86 7.86 0 0 1-5.511 2.25zM128.709 28.25l-4.299.45a1.597 1.597 0 0 1-1.765-1.586v-8.582c0-.814.615-1.498 1.426-1.586l4.299-.465a1.597 1.597 0 0 1 1.77 1.586v8.596c0 .816-.618 1.5-1.431 1.587"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E2E2E2",
      d: "M123.346 41.955a.157.157 0 0 1-.157-.156v-9.167a.157.157 0 0 1 .314 0V41.8c0 .086-.07.156-.157.156"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E2E2E2",
      d: "M121.747 34.585a.16.16 0 0 1-.157-.144.16.16 0 0 1 .145-.17l16.609-1.32a.16.16 0 0 1 .169.143.16.16 0 0 1-.144.17l-16.609 1.32z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#B26E3D",
      d: "M53.142 42.112a2.254 2.254 0 0 0 3.945-.545 2.24 2.24 0 0 0-1.308-2.865l-2.637 3.412z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#A97046",
      d: "M53.142 42.112a2.24 2.24 0 0 1-.29-2.083 2.254 2.254 0 0 1 2.887-1.343l.04.016"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#474747",
      d: "M55.74 38.684a2.254 2.254 0 0 0-2.888 1.344 2.24 2.24 0 0 0 .29 2.082L55.78 38.7l-.04-.016zM52.534 38.992a.925.925 0 1 0 .002-1.85.925.925 0 0 0-.002 1.85"
    })]
  }))]
});
export default SvgContactRequest;